import {Grid} from "@material-ui/core";
import MainOfferContent from "../main-offer-content/MainOfferContent";
import TopOfferItem from "../top-offer-item/TopOfferItem";
import WhiteHeaderCard from "../../../../../../components/ui/cards/white-header-card/WhiteHeaderCard";
import {useCallback} from "react";
import PropTypes from "prop-types";

const CurrentOffer = ({currentOffer}) => {

    const getGridSize = useCallback(() => {
        if (!currentOffer && !currentOffer.offertaTopItemList)
            return 4
        return 12 / currentOffer.offertaTopItemList.length
    }, [currentOffer])

    return (
        currentOffer ?
            <>
                <WhiteHeaderCard>
                    {/*Create items above the main zone offer*/}
                    <Grid container
                          spacing={3}>
                        {currentOffer.offertaTopItemList.map((item, index) => {
                            return (
                                <Grid item
                                      key={"offer-top-item-" + index}
                                      xs={12} sm={6} md={getGridSize()}>
                                    <TopOfferItem item={item}/>
                                </Grid>
                            )
                        })}
                    </Grid>

                    {/*Create the main part of the offerta with zones*/}
                    <MainOfferContent zoneData={currentOffer.offertaZoneItemList}
                                      planName={currentOffer.planName}/>
                </WhiteHeaderCard>
            </> : null
    )
}

CurrentOffer.propTypes = {
    currentOffer: PropTypes.object.isRequired
}

export default CurrentOffer;
